/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Calendar_Events_SuccessInputs */

const es_tools_calendar_events_success = /** @type {(inputs: Tools_Calendar_Events_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de Google obtenidos`)
};

const en_tools_calendar_events_success = /** @type {(inputs: Tools_Calendar_Events_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google events fetched`)
};

/**
* | output |
* | --- |
* | "Google events fetched" |
*
* @param {Tools_Calendar_Events_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_calendar_events_success = /** @type {((inputs?: Tools_Calendar_Events_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Calendar_Events_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_calendar_events_success(inputs)
	return en_tools_calendar_events_success(inputs)
});
export { tools_calendar_events_success as "tools.calendar.events_success" }